
import Vue from 'vue'
import Component from 'vue-class-component'
import { Model, Prop, Watch } from 'vue-property-decorator'
import Sheet from './Sheet.vue'
import { log } from '@/common'

@Component({ name: 'my-field', components: { Sheet } })
export default class IndexView extends Vue {
  @Model('change') val!: string
  @Prop({ type: String, default: 'text' }) type!: string
  @Prop({ type: String, default: '' }) secondType!: string
  @Prop({ type: String, default: '' }) prop!: string
  @Prop({ type: String, default: '' }) label!: string
  @Prop({ type: Number, default: 80 }) labelWidth!: number
  @Prop({ type: String, default: '-' }) maxlength!: string
  @Prop({ type: Boolean, default: false }) clearable!: boolean
  @Prop({ type: String, default: '' }) placeholder!: string
  @Prop({ type: Array, default: () => [] }) options!: any[]
  @Prop({ type: Boolean, default: false }) showCalcel!: boolean
  @Prop({ type: Boolean, default: true }) line!: boolean
  @Prop({ type: Boolean, default: false }) auto!: boolean
  @Prop({ type: Function, default: null }) selectAction!: (o: any, s: any) => void
  @Prop({ type: Function, default: null }) selectTrigger!: any
  @Prop({ type: String, default: '' }) error!: string
  @Prop({ type: Function, default: null }) errorAction!: (k: string) => void
  @Prop({ type: Function, default: null }) inputAction!: (v: string) => void
  @Prop({ type: Function, default: null }) formatter!: (v: string) => string
  @Prop({ type: Boolean, default: false }) disabled!: boolean
  @Prop({ type: Boolean, default: false }) resetBranch!: boolean
  @Prop({ type: Array, default: null }) branch!: any
  @Prop({ type: String, default: '' }) rightIcon!: string
  @Prop({ type: String, default: 'left' }) align!: string

  showSheet = false
  selected = ''
  selectedText = ''
  active = 0
  date1 = ''
  date2 = ''
  maxDate = new Date(3000, 11, 31)
  list: any = null
  tabs = ['', '', '']
  activetTab = 0
  selectedTarget = ''
  minYear = 2000
  maxYear = 2042
  columns = [
    { values: [] },
    {
      values: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
    },
    { values: [] },
  ]

  get value() {
    return this.val
  }

  set value(val) {
    let result = val.replace(/\s/, '')
    if (this.type === 'number') result = result.replace(/[^\d|\s]/g, '')
    if (this.formatter) result = this.formatter(val)
    this.inputAction && this.inputAction(val)
    this.$emit('change', result)
  }

  get formatActions() {
    if (this.type === 'select') {
      this.options.forEach((item: any) => {
        item.text = item.itemName
      })
    }
    return this.options
  }

  get date() {
    if (!this.val || this.type !== 'date') return ''
    const [s, e] = this.val.replace(/-/g, '.').split('_')
    let end = e
    if (e === '3000.12.31') end = '长期有效'
    return `${s}-${end}`
  }

  set date(val) {
    log(val)
  }

  get startDate() {
    if (this.type === 'date' && this.val) {
      const date = this.val.split('_')
      const [a, b, c] = date[0].split('-')
      return new Date(Number(a), Number(b) - 1, Number(c))
    }

    return new Date()
  }

  set startDate(val: Date) {
    log(val)
  }

  get endDate() {
    if (this.type === 'date' && this.val) {
      const date = this.val.split('_')
      const [a, b, c] = date[1].split('-')
      return new Date(Number(a), Number(b) - 1, Number(c))
    }

    return new Date()
  }

  set endDate(val: Date) {
    log(val)
  }

  @Watch('val')
  handleVal(val: any, oldVal: any) {
    if (val && !oldVal) {
      this.initSelect()
      this.initCascader()
    }
  }

  @Watch('auto')
  handleAuto(val: any, oldVal: any) {
    if (val && !oldVal) {
      this.handleShowSheet()
    }
  }
  @Watch('resetBranch')
  handlereSetBranch(val: any) {
    if (val) {
      this.initCascader()
    }
  }

  mounted() {
    this.initSelect()
    this.initCascader()
    this.initDate()
    this.auto && this.handleShowSheet()
  }

  initSelect() {
    if (this.type === 'select' && this.value) {
      log('initSelect', this.label)
      this.formatActions?.forEach((item, i) => {
        if (item.itemValue === this.value) {
          this.selectedText = item.text
          this.selected = i + ''
        }
      })

      if (this.selectTrigger && this.value) this.selectedText = this.value
    }
  }

  initCascader() {
    if (this.type === 'cascader') {
      log('initCascader', this.label)
      if (this.value) {
        const [p, c, a] = this.value.split('-')
        this.tabs[0] = p
        this.tabs[1] = c
        this.tabs[2] = a
        this.activetTab = 2
        this.selectedText = this.value
      } else {
        this.tabs[0] = ''
        this.tabs[1] = ''
        this.tabs[2] = ''
        this.activetTab = 0
        this.selectedText = ''
      }

      const types: any = {
        address: 'prov',
        branch: 'provinceName',
      }
      this.list = this.options?.map((item: any) => {
        item.text = item[types[this.secondType]]
        return item
      })
      log('list >>> ', this.list)
      if (this.secondType === 'address') {
        const city = this.list.filter((item: any) => item.text === this.tabs[0])
        if (!city?.length) return

        const target = city[0].city.filter((item: any) => item.cityName === this.tabs[1])
        if (!target?.length) return

        const coun = target[0].coun.map((item: any) => ({ text: item }))
        this.selectedTarget = this.tabs[2]
        this.list.splice(0, this.list.length)
        this.list.push.apply(this.list, coun)
      }

      if (this.secondType === 'branch') {
        if (this.branch) {
          this.tabs[0] = this.branch[0]
          this.tabs[1] = this.branch[1]
          this.tabs[2] = this.branch[2]
          this.activetTab = 2
          this.selectedText = this.branch[2]
          const citys = this.list?.filter((item: any) => item.text === this.tabs[0])
          if (!citys?.length) return

          const departments = citys[0]?.cities?.filter(
            (item: any) => item.cityName === this.tabs[1]
          )
          if (!departments?.length) return

          const list = departments[0]?.departments?.map((item: any) => ({
            ...item,
            text: item.name,
          }))
          this.selectedTarget = this.tabs[2]
          this.list.splice(0, this.list.length)
          this.list.push.apply(this.list, list)
          const target = list?.filter((item: any) => item.name === this.branch[2])
          this.selectAction(target[0], this.tabs)
        } else {
          this.tabs[0] = ''
          this.tabs[1] = ''
          this.tabs[2] = ''
          this.activetTab = 0
          this.selectedText = ''
        }
      }
    }
  }

  handleShowSheet() {
    if (this.selectTrigger) {
      this.selectTrigger()
    } else if (this.type === 'cascader' && this.disabled) {
      return
    } else {
      this.showSheet = true
    }
  }

  handleSelectCancel() {
    log('handleSelectCancel')
    this.showSheet = false
    if (this.type === 'cascader' && !this.tabs[2]) {
      if (this.value) {
        this.initCascader()
      } else {
        this.initCascaderProps()
      }
    }
  }

  initCascaderProps() {
    this.tabs[0] = ''
    this.tabs[1] = ''
    this.tabs[2] = ''
    this.activetTab = 0

    const types: any = {
      address: 'prov',
      branch: 'provinceName',
    }
    this.list = this.options?.map((item: any) => {
      item.text = item[types[this.secondType]]
      return item
    })
  }

  fmtCascader(i: number) {
    this.selectedTarget = ''
    this.selectedText = ''
    // this.$emit('change', this.selectedText)

    this.list.splice(0, this.list.length)

    if (!i) {
      this.list.push.apply(this.list, this.options)
      this.initCascaderProps()
    }

    if (i === 1) {
      const [item] = this.options.filter(item => item.text === this.tabs[0])
      log('city ', item)

      const types: any = {
        address: 'city',
        branch: 'cities',
      }
      const arr = item[types[this.secondType]]?.map((c: any) => {
        c.text = c.text || c.cityName
        return c
      })
      this.list.push.apply(this.list, arr)
      this.tabs[1] = ''
      this.tabs[2] = ''
      this.activetTab = 1
    }
  }

  handleInput(val: string) {
    const len = Number(this.maxlength)
    log('handleInput', val, len)
    if (len && val?.length >= len) {
      log('length >> ', len, val)
      this.value = val.substring(0, len)
    }
    this.$emit('input', this.value)
    // this.inputAction && this.inputAction()
    // if (this.formatter) this.formatter(this.value)
  }

  handleBlur() {
    this.errorAction && this.errorAction(this.prop)
  }

  handleSelect(i: number) {
    this.selected = i + ''
    const item = this.formatActions[i]
    this.selectedText = item.text
    this.$emit('change', item.itemValue)
    this.handleSelectCancel()
    this.errorAction && this.errorAction(this.prop)
  }

  handleCascaderSelect(i: number) {
    this.selected = i + ''
    const item = this.list[i]
    this.selectedTarget = item.text

    let propName = ''
    for (const key in item) {
      if (Object.prototype.hasOwnProperty.call(item, key)) {
        if (Array.isArray(item[key])) {
          propName = key
          log('propName', propName)
        }
      }
    }

    const actions: any = {
      0: () => {
        this.tabs[0] = item.text
        this.list.splice(0, this.list.length)
        const arr = item[propName]?.map((c: any) => {
          c.text = c.text || c.cityName
          return c
        })
        this.list.push.apply(this.list, arr)
        this.activetTab = 1
      },
      1: () => {
        this.tabs[1] = item.text
        this.list.splice(0, this.list.length)
        const arr = item[propName]?.map((c: any) => {
          if (this.secondType === 'address') return { text: c }
          c.text = c.name || ''
          return c
        })
        this.list.push.apply(this.list, arr)
        this.activetTab = 2
      },
      2: () => {
        this.tabs[2] = item.text
        log('tabs >>> ', this.tabs)
        if (this.selectAction) {
          this.selectedText = item.text
          this.selectAction(item, this.tabs)
        } else {
          this.selectedText = this.tabs.join('-')
          this.$emit('change', this.selectedText)
        }
        this.handleSelectCancel()
        this.errorAction && this.errorAction(this.prop)
      },
    }

    actions[this.activetTab]()
  }

  initDate() {
    if (this.type === 'date' && this.val) {
      const result = this.val.split('_')
      log('result >>> ', result)
      this.date1 = result[0].replace(/-/g, '.')
      this.date2 = result[1].replace(/-/g, '.')
    }
  }

  clickDate() {
    if (this.disabled) return
    this.showSheet = true
  }

  initColum() {
    if (!(this.type === 'date' && this.val)) return

    const [start, end] = this.val.split('_')
    this.date1 = start.replace(/-/g, '.')
    this.date2 = end.replace(/-/g, '.')

    const yearArr = this.getYearArr()
    const el: any = this.$refs.picker
    let days = this.DayCount(
      `${new Date().getFullYear()}-${this.getNumStr(new Date().getMonth() + 1)}`
    )
    this.columns[0].values = yearArr
    this.columns[2].values = this.getDaysArr(days)
    this.$nextTick(() => {
      let year = ''
      let month = ''
      let day = ''

      if (!this.active) {
        year = start[0]
        month = start[1]
        day = start[2]
      } else {
        if (end[0] === '长期有效') {
          year = end[0]
          month = '01'
          day = '31'
        } else {
          year = end[0]
          month = end[1]
          day = end[2]
        }
      }
      el.setValues([year, month, day])
    })
  }

  getYearArr() {
    const yearArr = []
    if (this.active) {
      yearArr.push('长期有效')
    }

    const [s, e] = this.val.split('_')
    const start = s.split('-')
    const end = e.split('-')
    if (!this.active) {
      this.minYear = +start[0] - 25
      this.maxYear = +start[0] + 25
    } else {
      if (end[0] !== '长期有效') {
        this.minYear = +end[0] - 25
        this.maxYear = +end[0] + 25
      } else {
        this.minYear = +start[0] - 25
        this.maxYear = +start[0] + 25
      }
    }

    for (let i = 0; this.minYear + i < this.maxYear; i++) {
      yearArr.push(`${this.maxYear - i}`)
    }
    return yearArr
  }

  DayCount(str: string) {
    let date = new Date(str)
    date.setMonth(date.getMonth() + 1)
    date.setDate(0)
    return date.getDate()
  }

  getNumStr(num: number) {
    return num < 10 ? `0${num}` : `${num}`
  }

  getDaysArr(days: number) {
    const daysArr = []
    for (let i = 0; i < days; i++) {
      daysArr.push(`${i + 1 < 10 ? '0' + (i + 1) : i + 1}`)
    }
    return daysArr
  }

  handleLeft() {
    log('handleLeft')
    this.initDate()
  }

  handleRight() {
    log('handleRight')
    const s = this.date1.replace(/\./g, '-')
    const e = this.date2.replace(/\./g, '-')
    this.value = `${s}_${e}`
  }

  changeStartDate(date: any) {
    this.date1 = date.getValues().join('.')
  }

  changeEndDate(date: any) {
    this.date2 = date.getValues().join('.')
  }

  handleFormat(val: string) {
    log('handleFormat', this.value)
    if (!this.value) return ''
    if (!val) return this.value || ''
    return this.formatter ? this.formatter(val) : val
  }
}
